import { TOrder, TOrderItem } from '@components/types';
import { getCombinedName } from '@components/variant/variantSelector';
import appConfig from '@core/appconfig';
import {
    calculateCost,
    calculateTax,
    groupBy,
    trimToLength
} from '@core/utils';
import { MapPin } from 'lucide-react';
import Moment from 'moment';
import React from 'react';

interface Props {
    order?: TOrder;
}

export class PrintOrderComponent extends React.Component<Props> {
    render() {
        const { order } = this.props
        const discountedTotal = order?.orderitems?.reduce(
            (prevTotal, current) => prevTotal + current.price * current.quantity,
            0
        );
        const total = order?.orderitems?.reduce(
            (prevTotal, current) => prevTotal + current.mrp * current.quantity,
            0
        );
        const savings = total - discountedTotal;
        // const totalTax = order?.orderitems?.reduce((prevTax, currentTax) => prevTax + (currentTax?.inventory?.tax_exclusive ? ((currentTax.price * currentTax.inventory.tax_rate) / 100 * currentTax.quantity) : ((currentTax.inventory.tax_rate * (currentTax.price / (1 + (currentTax.inventory.tax_rate) / 100))) / 100 * currentTax.quantity)), 0)
        // const grandTotal = order?.orderitems?.reduce((prevTax, currentTax) => prevTax + (currentTax?.inventory?.tax_exclusive ? ((((currentTax.price * currentTax.inventory.tax_rate) / 100) + currentTax?.price) * currentTax.quantity) : (currentTax?.price * currentTax.quantity)), 0)
        const grandTotal = order?.orderitems?.reduce(
            (prev, current) =>
                prev +
                (current?.inventory?.tax_exclusive
                    ? current?.total_cost
                    : current?.total_payable),
            0
        );

        const taxGroup = groupBy(order?.orderitems, (oi) => {
            return oi.inventory.tax_rate;
        });
        const taxCalculate = Object?.entries(taxGroup || {})?.map((element) => {
            let tax = parseFloat(element[0]);
            let orderItems = element[1];
            return {
                SGST: tax / 2,
                CGST: tax / 2,
                tax: calculateTax(orderItems) / 2,
                amount: calculateCost(orderItems),
            };
        });
        const roundOff = Math.round(order?.payable) - order?.payable;

        return (
            <div>
                <div className="flex md:flex-row flex-col justify-center items-center bg-white gap-4 w-full">
                    <div className="grid gap-1 h-fit md:w-1/3 rounded-md bg-white p-4">
                        <div className="flex justify-center text-neutral-900 font-semibold text-base leading-tight">
                            Invoice/ Bill
                        </div>
                        <div className="grid pb-1 border-black border-b border-b-dashed gap-1">
                            <div className="flex flex-col gap-1 pb-1 border-b border-black border-b-dashed">
                                <div className="flex justify-between gap-2">
                                    <div className="text-neutral-900 text-sm font-semibold">
                                        <span className="text-neutral-700 text-sm font-semibold">
                                            Sold By:{' '}
                                        </span>
                                        {order?.store?.name}
                                    </div>

                                    <div className="flex justify-end text-neutral-900 items-start print:hidden whitespace-nowrap">
                                        <span className="text-sm print:hidden">
                                            Mob : {order?.store?.phone}{' '}
                                        </span>
                                    </div>
                                </div>
                                <div className="flex justify-between gap-2">
                                    <div className="text-sm">
                                        <span className="text-neutral-700 font-semibold">
                                            Shop Address :{' '}
                                        </span>
                                        {[
                                            order?.store?.address?.house_number,
                                            order?.store?.address?.street_name,
                                            order?.store?.address?.locality,
                                            order?.store?.address?.city?.name,
                                            order?.store?.address?.state?.name,
                                            order?.store?.address?.pincode,
                                        ]
                                            .filter((x) => x != undefined)
                                            .join(', ')}
                                    </div>

                                    <div className="flex justify-end text-sky-500 items-start print:hidden">
                                        <a
                                            href={`http://www.google.com/maps/place/${order?.store?.address?.latitude},${order?.store?.address?.longitude}`}
                                            target="_blank"
                                        >
                                            <button
                                                type="button"
                                                className="w-fit px-2 py-1 flex items-center gap-0.5 text-xs text-white font-manrope font-semibold leading-none rounded-full bg-green-500 cursor-pointer print:hidden select-none"
                                            >
                                                Location{' '}
                                                <MapPin className="w-3 h-3 text-white" />
                                            </button>
                                        </a>
                                    </div>

                                </div>
                                {order?.store?.gstin != null ? (
                                    <div className="text-neutral-900 text-sm font-semibold">
                                        <span className="text-neutral-700 text-sm font-semibold">
                                            GSTIN:{' '}
                                        </span>
                                        {order?.store?.gstin}
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                            <div className="flex flex-col gap-1">
                                <div className="flex justify-between gap-2">
                                    <div className="text-neutral-900 text-sm font-medium">
                                        <span className="text-neutral-700 text-sm">
                                            Customer Name:{' '}
                                        </span>
                                        <span className="font-medium">
                                            {order?.user?.full_name}
                                        </span>
                                    </div>

                                    <div className="flex justify-end text-neutral-900 items-start print:hidden whitespace-nowrap">
                                        <span className="text-neutral-700 font-medium text-sm print:hidden">
                                            Mob:{' '}
                                        </span>
                                        <span className="text-neutral-900 text-sm">{order?.user?.phone}{' '}
                                        </span>
                                    </div>

                                </div>
                                {order?.address != null || order?.shipping_address !== null ? (
                                    <div className="flex justify-between gap-2">
                                        <div className="text-sm">
                                            <span className="text-neutral-700 font-semibold">
                                                Delivery Address:{' '}
                                            </span>
                                            {[
                                                order?.address?.house_number || order?.shipping_address?.house_number,
                                                order?.address?.street_name || order?.shipping_address?.street_name,
                                                order?.address?.locality || order?.shipping_address?.locality,
                                                order?.address?.city?.name || order?.shipping_address?.city?.name,
                                                order?.address?.state?.name || order?.shipping_address?.state?.name,
                                                order?.address?.pincode || order?.shipping_address?.pincode,
                                            ]
                                                .filter((x) => x != undefined)
                                                .join(', ')}
                                        </div>
                                        <div className="flex gap-1 justify-end text-sky-500 items-start print:hidden">
                                            <a
                                                href={`http://www.google.com/maps/place/${order?.address?.latitude},${order?.address?.longitude}`}
                                                target="_blank"
                                            >
                                                <button
                                                    type="button"
                                                    className="w-fit px-2 py-1 flex items-center gap-0.5 text-xs text-white font-manrope font-semibold leading-none rounded-full bg-green-500 cursor-pointer print:hidden select-none"
                                                >
                                                    Location{' '}
                                                    <MapPin className="w-3 h-3 text-white" />
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                        <div className="grid border-b border-black border-b-dashed">
                            {order?.bill_id && (
                                <div className="text-sm">
                                    <span className="font-medium text-neutral-600">
                                        Bill Id:{' '}
                                    </span>
                                    {order?.bill_id}
                                </div>
                            )}
                            <div className="text-sm">
                                <span className="font-semibold text-neutral-600">
                                    Order Id:{' '}
                                </span>
                                #{order?.short_id || order?.id}
                            </div>
                            <div className="text-sm">
                                <span className="font-semibold text-neutral-600">Date:</span>{' '}
                                {Moment(order.added_on).format('YYYY-MM-DD')}{' '}
                                {Moment(order.added_on).format('HH:mm')}
                            </div>
                            {order?.info?.table && (
                                <div className="text-sm">
                                    <span className="font-medium text-neutral-600">
                                        Table No:{' '}
                                    </span>
                                    {order?.info?.table}
                                </div>
                            )}
                        </div>
                        <div className="bg-white">
                            <div className="grid grid-cols-6 border-black border-b border-b-dashed p-1">
                                <div className="grid col-span-2">
                                    <div className="flex text-neutral-900 font-semibold text-sm">
                                        Item
                                    </div>
                                    <div className="flex text-neutral-900 font-semibold text-sm">
                                        Item Code
                                    </div>
                                </div>
                                <div className="col-span-2 text-neutral-900 font-semibold flex justify-center text-sm">
                                    Qty{' '}
                                </div>
                                <div className="grid col-span-2">
                                    <div className="text-neutral-900 font-semibold flex justify-end text-sm">
                                        Unit Amt
                                    </div>
                                    <div className="text-neutral-900 font-semibold flex justify-end text-sm">
                                        Total Amt
                                    </div>
                                </div>
                                {/* <div className="text-neutral-900 font-semibold flex justify-center text-sm">Rate(₹)</div> */}
                            </div>
                            {order?.orderitems &&
                                order?.orderitems.map((orderItem: TOrderItem) => {
                                    return (
                                        <div className="grid border-b border-black border-b-dashed w-full items-start p-1">
                                            <div
                                                className="grid grid-cols-6 "
                                                key={orderItem?.id}
                                                data-orderitem-id={orderItem.id}
                                            >
                                                <div className="grid col-span-2">
                                                    <div className="flex text-neutral-900 line-clamp-2 text-sm overflow-hidden">
                                                        {trimToLength(getCombinedName(orderItem?.inventory?.product, orderItem?.inventory?.variant_id) || orderItem?.inventory?.product?.name, 40)}
                                                    </div>
                                                    <div className="flex text-neutral-900 text-sm overflow-hidden">
                                                        {orderItem?.inventory?.product?.gtin}
                                                    </div>

                                                </div>
                                                <div className="col-span-2 text-neutral-900 flex justify-center text-sm">
                                                    {orderItem?.quantity}{' '}
                                                </div>
                                                <div className="grid col-span-2">
                                                    <div className="text-neutral-900 flex justify-end text-sm">
                                                        ₹{orderItem?.price?.toFixed(2)}
                                                    </div>
                                                    <div className="text-neutral-900 font-semibold flex justify-end text-sm">
                                                        ₹{orderItem?.total_cost?.toFixed(2)}
                                                    </div>
                                                </div>
                                            </div>
                                            {orderItem?.add_ons?.length > 0 &&
                                                <div className="flex flex-row text-xs gap-1 ">
                                                    <span className="font-semibold">Addon :</span>
                                                    {orderItem?.add_ons?.map((x) => x?.inventory?.product?.name)?.filter((x) => x != undefined).join(", ")}

                                                </div>
                                            }
                                        </div>
                                    );
                                })}
                            <div className="grid grid-cols-6 border-b border-black border-b-dashed w-full items-start p-1">
                                <div className="grid col-span-3 text-sm text-neutral-900">
                                    Total Qty : {order?.orderitems?.length}
                                </div>
                                <div className="grid justify-end col-span-3 text-sm text-neutral-900">
                                    Total : ₹{grandTotal?.toFixed(2)}
                                </div>
                            </div>
                            {order?.tax != 0 ? (
                                <div className="grid border-b border-black border-b-dashed w-full items-start p-1 gap-1">
                                    <div className="text-neutral-900 font-semibold text-md">
                                        Tax Information
                                    </div>
                                    {taxCalculate?.map((taxComponent) => {
                                        if (taxComponent?.tax > 0) {
                                            return (
                                                <div className="grid" key={taxComponent?.tax}>
                                                    <div className="flex flex-row items-center justify-between">
                                                        <span className="text-neutral-900 text-sm font-semibold">
                                                            Taxable amount
                                                        </span>
                                                        <span className="text-sm text-neutral-900">
                                                            ₹{taxComponent?.amount?.toFixed(2)}
                                                        </span>
                                                    </div>
                                                    <div className="flex flex-row items-center justify-between">
                                                        <span className="text-neutral-900 text-sm">
                                                            CGST {taxComponent?.CGST}%
                                                        </span>
                                                        <span className="text-sm text-neutral-900">
                                                            ₹{taxComponent?.tax?.toFixed(2)}
                                                        </span>
                                                    </div>
                                                    <div className="flex flex-row items-center justify-between">
                                                        <span className="text-neutral-900 text-sm">
                                                            SGST {taxComponent?.SGST}%
                                                        </span>
                                                        <span className="text-sm text-neutral-900">
                                                            ₹{taxComponent?.tax?.toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        }
                                    })}
                                    <div className="flex flex-row justify-between">
                                        <span className="text-neutral-900 font-semibold text-sm">
                                            Total Tax
                                        </span>
                                        <span className="text-sm text-neutral-900">
                                            ₹{order?.tax?.toFixed(2)}
                                        </span>
                                    </div>
                                    {order?.charges?.length > 0 &&
                                        order?.charges?.map((charge) => (
                                            <div
                                                key={charge?.id}
                                                className="flex justify-between items-center"
                                            >
                                                <span className="text-sm text-neutral-900 font-manrope font-medium">
                                                    {charge?.charge.display_name}
                                                </span>
                                                <span className="text-sm text-neutral-900 font-manrope font-medium">
                                                    ₹{charge?.total_cost?.toFixed(2)}
                                                </span>
                                            </div>
                                        ))}
                                </div>
                            ) : (
                                <></>
                            )}
                            <div className="grid border-b border-black border-b-dashed w-full items-start p-1">
                                {savings != 0 ? (
                                    <div className="flex flex-row justify-between">
                                        <span className="text-neutral-900 font-semibold text-sm">
                                            Savings
                                        </span>
                                        <span className="text-sm text-neutral-900">
                                            ₹{savings?.toFixed(2)}
                                        </span>
                                    </div>
                                ) : (
                                    <></>
                                )}
                                {/* <div className="flex flex-row justify-between">
                                    <span className="text-neutral-900 font-semibold text-sm">Total Tax</span>
                                    <span className="text-sm text-neutral-900">₹{totalTax.toFixed(2)}</span>
                                </div> */}
                                {roundOff != 0 && (
                                    <div className="flex flex-row justify-between">
                                        <span className="text-neutral-900 text-sm">Round Off</span>
                                        <span className="text-sm text-neutral-900">
                                            {roundOff.toFixed(2)}
                                        </span>
                                    </div>
                                )}
                                <div className="flex flex-row justify-between">
                                    <span className="text-neutral-900 font-semibold text-sm">
                                        Grand Total
                                    </span>
                                    <span className="text-sm text-neutral-900 font-semibold">
                                        ₹{Math.round(order?.payable).toFixed(2)}
                                    </span>
                                </div>
                            </div>
                            <div className="grid border-b border-black border-b-dashed w-full items-start p-1">
                                <div className="flex justify-center text-xs font-semibold text-neutral-900">
                                    Powered by
                                </div>
                                <div className="flex justify-center text-xs font-semibold text-neutral-900">
                                    {appConfig?.appName}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
